import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../../global/commonStyle';

export const UploadText = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  ${mobile_xl(css`
    gap: var(--space-2);
  `)}
`;

export const Overlay = styled.div`
  background-color: var(--background-hover);
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  position: absolute;
  display: none;
  justify-content: center;
  border-radius: var(--border-radius-full);
  cursor: pointer;
  ${mobile_xl(css`
    width: 60px;
    height: 60px;
  `)}
`;

export const EditIcon = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
`;

export const InvoiceLogo = styled.div`
  position: relative;
  ${FlexCenter}
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-full);
  width: 40px;
  height: 40px;
  cursor: pointer;
  &:hover {
    .profile-image {
      filter: blur(1.5px);
      -webkit-filter: blur(1.5px);
    }
    ${Overlay} {
      display: flex;
    }
  }
  img {
    border-radius: var(--border-radius-full);
    object-fit: contain;
  }
  ${mobile_xl(css`
    width: 60px;
    height: 60px;
    img {
      width: 60px;
      height: 60px;
    }
  `)}
`;

export const SubContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-40);
  padding: var(--space-16) var(--space-20);
  ${mobile_xl(css`
    gap: var(--space-20);
    padding: var(--space-20) var(--space-0);
  `)}
`;

export const Autotext = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  max-width: 532px;
  width: 100%;
  ${mobile_xl(css`
    border-bottom: 0.5px solid var(--border-primary);
    padding: var(--space-0) var(--space-20) var(--space-20);
    width: calc(100% - 40px);
    gap: var(--space-16);
  `)}
`;
export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  ${mobile_xl(css`
    gap: var(--space-16);
  `)}
`;

export const InputSide = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
  ${mobile_xl(css`
    display: grid;
    grid-template-columns: 1.6fr 1fr 0.3fr;
  `)}
`;

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  ${mobile_xl(css`
    gap: var(--space-16);
  `)}
`;

export const SectionTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
`;
export const Title = styled.p`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
  margin: var(--space-0);
`;
export const AddTask = styled.div`
  ${AlignCenter}
  gap: var(--space-5);
`;

export const PlusIcon = styled.div`
  ${FlexCenter}
`;

export const Features = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  ${mobile_xl(css`
    gap: var(--space-8);
    padding-inline: var(--space-20);
  `)}
`;
export const InvoiceDue = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  ${mobile_xl(css`
    gap: var(--space-4);
  `)}
`;
export const RadioButtonWrapper = styled.div`
  ${mobile_xl(css`
    padding-block: var(--space-10);
  `)}
`;
